import React from "react";

const servicesData = [
    { id: 'PARK', code : 'PARK'}
    , { id: 'HOTEL', code : 'HOTEL'}
];

export const servicesXlProvider = {
    getOptions : getServicesXlOptions,
    getItem : getServicesXlItem
};

async function getServicesXlOptions() {
    try {
        return servicesData.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <div><label>{item.code}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

function getServicesXlItem(id) {
    if (!id)
        return null;

    const item = servicesData.find(psd => psd.id === id)
    try {
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>,
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}

const servicesStatusData = [
      { id: 1,      code : 'CANCEL',            row: '[1] CANCEL'}
    , { id: 2,      code : 'REFUND',            row: '[2] REFUND'}
    , { id: 3,      code : 'UPGRADE',           row: '[3] UPGRADE'}
    , { id: 4,      code : 'IN-PROCESS',        row: '[4] IN-PROCESS'}
    , { id: 5,      code : 'MODIFY',            row: '[5] MODIFY'}
    , { id: 7,      code : 'PAID',              row: '[7] PAID'}
    , { id: 21,     code : 'EXPIRED',           row: '[21] EXPIRED'}
    , { id: 23,     code : 'COURTESY',          row: '[23] COURTESY'}
    , { id: 24,     code : 'RESERVED',          row: '[24] RESERVED'}
    , { id: 25,     code : 'CHARGE BACK',       row: '[25] CHARGE BACK'}
    , { id: 36,     code : 'PENALTY',           row: '[36] PENALTY'}
    , { id: 37,     code : 'INVOICED',          row: '[37] INVOICED'}
    , { id: 38,     code : 'RESERVED AGENCY',   row: '[38] RESERVED AGENCY'}
    , { id: 9999,   code : 'UNKNOWN',           row: '[9999] UNKNOWN'}
];

export const servicesStatusProvider = {
    getOptions : getServicesStatusOptions,
    getItem : getServicesStatusItem
};

async function getServicesStatusOptions() {
    try {
        return servicesStatusData.map((itemData) => {
            const {id, code} = itemData
            return (
                {
                    id: id,
                    value: code,
                    label: <div><label>{code}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

function getServicesStatusItem(id) {
    if (!id)
        return null;

    const item = servicesStatusData.find(psd => psd.id === id)
    try {
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>,
                row: item.row
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}

const paymentStatusData = [
      { id: 1,      code : 'DECLINED',          row: '[1] DECLINED'}
    , { id: 2,      code : 'APROVED',           row: '[2] APROVED'}
    , { id: 3,      code : 'REJECTED',          row: '[3] REJECTED'}
    , { id: 5,      code : 'IN-PROCESS',        row: '[5] IN-PROCESS'}
    , { id: 6,      code : 'PAYMENT PLAN',      row: '[6] PAYMENT PLAN'}
    , { id: 100,    code : 'PAY-PAL',           row: '[] PAY-PAL'}
    , { id: 9998,   code : 'NOT DISPONIBILITY', row: '[9998] NOT DISPONIBILITY'}
    , { id: 9999,   code : 'UNKNOWN',           row: '[9999] UNKNOWN'}
];

export const paymentStatusProvider = {
    getOptions : getPaymentStatusOptions,
    getItem : getPaymentStatusItem
};

async function getPaymentStatusOptions() {
    try {
        return paymentStatusData.map((itemData) => {
            const {id, code} = itemData
            return (
                {
                    id: id,
                    value: code,
                    label: <div><label>{code}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

function getPaymentStatusItem(id) {
    if (!id)
        return null;

    const item = paymentStatusData.find(psd => psd.id === id)

    try {
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>,
                row: item.row
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}